//src/components/steps/PropertyTitleTipsModal.jsx
import Swal from "sweetalert2";
import "../../styles/propertyTipsModal.css";
import { SELL_PROPERTY_TIPS } from "../sellProperty.constants";

export const openPropertyTitleTipsModal = async () => {
  await Swal.fire({
    title: "Tips Menulis Judul Iklan",
    width: 1000,
    padding: "24px",
    showConfirmButton: false,
    showCloseButton: true,
    allowOutsideClick: true,
    allowEscapeKey: true,
    customClass: {
      popup: "property-tips-modal",
      title: "property-tips-modal-title",
      htmlContainer: "property-tips-modal-content",
    },
    html: `
    <div class="property-tips-wrapper">
    <div class="property-tips-description">
        Gunakan kata kunci berikut agar iklan lebih mudah ditemukan dan
        menarik perhatian calon pembeli maupun penyewa.
    </div>

    <div class="property-tips-grid">
        ${SELL_PROPERTY_TIPS.map(
        (tip) => `
            <div class="property-tip-item">
            • ${tip}
            </div>
        `
        ).join("")}
    </div>

    <div class="property-tips-example">
        <div class="property-tips-example-title">
        Contoh Judul yang Menarik
        </div>

        <ul>
        <li>Rumah Minimalis 2 Lantai Lokasi Strategis Dekat Tol Pasteur</li>
        <li>Rumah Siap Huni Bebas Banjir di Bandung Selatan</li>
        <li>Apartemen Fully Furnished Harga Terbaik Dekat Kampus</li>
        <li>Tanah Hook Cocok untuk Investasi di Area Berkembang</li>
        </ul>
    </div>

    </div>
    `,
  });
};
